export default __webpack_public_path__ + "static/overall-bf8df601e3a847bc924bc1e54a9336c6.png";